import React from "react";
import styled from "styled-components/macro";
import RotateScreen from "../../images/MyTulu/RotateScreen.png";

export default function PlsRotate() {
  return (
    <Wrapper>
      <Img src={RotateScreen} />
      <AskText>Please rotate your device</AskText>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: #214d5c;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 74.3px;
  height: 68.6px;
`;

const AskText = styled.span`
  margin-top: 25.4px;
  font-family: DMSans;
  font-size: 15px;
  color: #fff;
`;
